import React from "react";
import MDBox from "shared/ui/Box/MDBox";
import Icon from "@mui/material/Icon";
import PropTypes from "prop-types";
import colors from "app/theme/base/colors";
import { alpha } from "@mui/material/styles";

export default function ExerciseSearch({ value, onChange }) {
  return (
    <MDBox
      sx={{
        width: "100%",
        boxSizing: "border-box",
        padding: "12px 12px",
        borderRadius: "12px",
        backgroundColor: "background.paper",
        border: "1px solid",
        borderColor: "grey.300",
        boxShadow: "none",
        display: "flex",
        alignItems: "center",
        gap: "10px",
        transition: "all 0.15s ease",
        marginBottom: "12px",
        "&:focus-within": {
          borderColor: "primary.main",
          boxShadow: (theme) => `0 0 0 3px ${alpha(theme.palette.primary.main, 0.18)}`,
        },
      }}
    >
      <Icon sx={{ fontSize: 20, color: "text.secondary", flexShrink: 0 }}>search</Icon>

      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Buscar..."
        style={{
          flex: 1,
          width: "100%",
          minWidth: 0,
          border: "none",
          outline: "none",
          fontSize: "0.88rem",
          background: "transparent",
          color: colors.text.primary,
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      />
    </MDBox>
  );
}

ExerciseSearch.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
